import Table from './Table';
import Cell from './Cell';

export { Cell };

export default Table;
